import { Checkbox } from '@schibsted-svp/react-ui';

import type { FormikHelpers } from 'formik';

import styles from './UsePageTaxonomyCheckbox.module.scss';

type Props = {
  taxonomy: string;
  checked: boolean;
  setFieldValue: FormikHelpers<unknown>['setFieldValue'];
};

function UsePageTaxonomyCheckbox({ taxonomy, checked, setFieldValue }: Props) {
  return (
    <div className={styles.container}>
      <Checkbox
        label={`Use page ${taxonomy}`}
        checked={checked}
        onChange={(event) => {
          const value = event.target.checked;

          setFieldValue('options.usePageTaxonomy', value);
        }}
      />
    </div>
  );
}

export { UsePageTaxonomyCheckbox };
